'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAvatar = require('react-avatar');

var _reactAvatar2 = _interopRequireDefault(_reactAvatar);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScopeSelector = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ScopeSelector, _Component);

  function ScopeSelector(props) {
    (0, _classCallCheck3.default)(this, ScopeSelector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScopeSelector.__proto__ || (0, _getPrototypeOf2.default)(ScopeSelector)).call(this, props));

    var selected = void 0;
    var id = void 0;
    if (props.queryParams.organization_id) {
      id = parseInt(props.queryParams.organization_id, 10);
      selected = props.organizations.find(function (org) {
        return org.id === id;
      });
    } else if (props.queryParams.calendar_id) {
      id = parseInt(props.queryParams.calendar_id, 10);
      selected = props.calendars.find(function (cal) {
        return cal.id === id;
      });
    }

    _this.state = {
      selected: selected
    };
    return _this;
  }

  (0, _createClass3.default)(ScopeSelector, [{
    key: 'changeSelection',
    value: function changeSelection(event) {
      var _props = this.props,
          calendars = _props.calendars,
          handleChange = _props.handleChange,
          organizations = _props.organizations; // eslint-disable-line no-shadow

      var eventKeyArray = event.split('-');
      var type = eventKeyArray[0];
      var id = parseInt(eventKeyArray[1], 10);

      var queryParams = this.props.queryParams;

      var newParams = (0, _extends3.default)({}, queryParams);

      var selected = void 0;
      switch (type) {
        case 'calendar':
          selected = calendars.find(function (cal) {
            return cal.id === id;
          });
          newParams.organization_id = '';
          newParams.calendar_id = selected.id;
          break;
        case 'organization':
          selected = organizations.find(function (org) {
            return org.id === id;
          });
          newParams.calendar_id = '';
          newParams.organization_id = selected.id;
          break;
        default:
          newParams.calendar_id = '';
          newParams.organization_id = '';
          selected = null;
          break;
      }

      handleChange(newParams);

      this.setState({
        selected: selected
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          calendars = _props2.calendars,
          organizations = _props2.organizations,
          polyglot = _props2.polyglot; // eslint-disable-line no-shadow

      var selected = this.state.selected;


      var title = _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_reactAvatar2.default, {
          ref: 'breadcrumbAvatar',
          size: 26,
          src: selected && selected.avatar && selected.avatar.sizes.thumbnail ? selected.avatar.sizes.thumbnail : '',
          name: selected ? selected.name : 'C'
        }),
        ' ',
        selected ? selected.name : polyglot.t('scopeSelector.all')
      );

      var organizationsHeader = void 0;
      var organizationsList = void 0;
      if (organizations.length) {
        organizationsHeader = _react2.default.createElement(
          _reactBootstrap.MenuItem,
          { header: true },
          polyglot.t('scopeSelector.organizations')
        );
        organizationsList = organizations.map(function (organization) {
          return _react2.default.createElement(
            _reactBootstrap.MenuItem,
            {
              key: 'organization-' + organization.id,
              eventKey: 'organization-' + organization.id
            },
            organization.name
          );
        });
      }

      var calendarsHeader = void 0;
      var calendarsList = void 0;
      if (calendars.length) {
        calendarsHeader = _react2.default.createElement(
          _reactBootstrap.MenuItem,
          { header: true },
          polyglot.t('scopeSelector.calendars')
        );
        calendarsList = calendars.map(function (calendar) {
          return _react2.default.createElement(
            _reactBootstrap.MenuItem,
            {
              key: 'calendar-' + calendar.id,
              eventKey: 'calendar-' + calendar.id
            },
            calendar.name
          );
        });
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'ol',
          { className: 'breadcrumb' },
          _react2.default.createElement(
            'li',
            { className: 'dropdown' },
            _react2.default.createElement(
              _reactBootstrap.DropdownButton,
              { id: 'breadcrumbActiveUser', title: title, onSelect: this.changeSelection.bind(this) },
              _react2.default.createElement(
                _reactBootstrap.MenuItem,
                { eventKey: 'all-0' },
                polyglot.t('scopeSelector.all')
              ),
              calendarsHeader,
              calendarsList,
              organizationsHeader,
              organizationsList
            )
          )
        )
      );
    }
  }]);
  return ScopeSelector;
}(_react.Component), _class.propTypes = {
  calendars: _propTypes2.default.array,
  organizations: _propTypes2.default.array,
  handleChange: _propTypes2.default.func.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  queryParams: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  organizations: [],
  calendars: []
}, _temp);
exports.default = ScopeSelector;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScopeSelector/ScopeSelector.js
// module id = 2242
// module chunks = 0